import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import './App.css'
import Home from "./pages/Home";
import Products from "./pages/Products";
import SingleProduct from './pages/SingleProduct'
import Contact from './pages/Contact';
import Checkout from './pages/Checkout'
import Signin from './pages/Signin';
import Signup from './pages/Signup';
import Thankyou from './pages/Thankyou';
import Settings from './pages/Profile/Settings';
import History from './pages/Profile/History';
import Favorites from './pages/Profile/Favorites';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/products" element={<Products />} />
      <Route path="/product" element={<SingleProduct />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/signin" element={<Signin />} />
      <Route path="/signup" element={<Signup />} />

      <Route path="/profile/settings" element={<Settings />} />
      <Route path="/profile/history" element={<History />} />
      <Route path="/profile/favorites" element={<Favorites />} />


      <Route path="/thankyou" element={<Thankyou />} />
    </Routes>
  </BrowserRouter>
);
